import { render, staticRenderFns } from "./BetslipTicket.vue?vue&type=template&id=2a64c3f5&scoped=true"
import script from "./BetslipTicket.vue?vue&type=script&lang=js"
export * from "./BetslipTicket.vue?vue&type=script&lang=js"
import style0 from "./BetslipTicket.vue?vue&type=style&index=0&id=2a64c3f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64c3f5",
  null
  
)

export default component.exports